export default "__VITE_ASSET__fc6d63c8__"